const UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;

/**
 * Generate an upload identity on browsers both with and without randomUUID.
 * There is intentionally no Math.random fallback: upload ids are persisted and
 * used for idempotency, so an unavailable cryptographic source must fail loudly.
 */
export function newUploadId(): string {
	const cryptoSource = globalThis.crypto;
	if (typeof cryptoSource?.randomUUID === "function") return cryptoSource.randomUUID();
	if (typeof cryptoSource?.getRandomValues !== "function") {
		throw new Error("Cryptographic randomness is unavailable; cannot create an upload id");
	}

	const bytes = cryptoSource.getRandomValues(new Uint8Array(16));
	bytes[6] = (bytes[6] & 0x0f) | 0x40;
	bytes[8] = (bytes[8] & 0x3f) | 0x80;
	const hexadecimal = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
	const id = `${hexadecimal.slice(0, 8)}-${hexadecimal.slice(8, 12)}-${hexadecimal.slice(12, 16)}-${hexadecimal.slice(
		16,
		20
	)}-${hexadecimal.slice(20)}`;
	if (!UUID_V4_PATTERN.test(id)) throw new Error("Cryptographic randomness produced an invalid upload id");
	return id;
}
